import React from 'react';
import NoResults from 'components/NoResults/NoResults';
import NO_RESULTS from 'assets/no-results.svg';
import WARN from '@arrive/ui-icons/svg/ic_warning.svg';

import { searchSplitter } from 'helpers/urlHelpers';

type ApolloServerErrorCodeType = 'UNAUTHENTICATED' | "GENERIC";

export const ApolloServerErrorCode = {
  UNAUTHENTICATED: 'UNAUTHENTICATED'
};

const getErrorDisplay = (code: ApolloServerErrorCodeType) => {
  let content = 'Refresh the session and try again.';
  let icon = NO_RESULTS;
  let title = 'An Error Occurred';
  const actionText = 'Refresh Session';
  // Redirect back to the landing page and let the security interceptor handle re-auth flow.
  const onActionClick = () => {
    try {
      // eslint-disable-next-line
      // @ts-ignore
      history.pushState({}, '', window.location.origin);
      window.location.reload();
      return true;
    } catch {
      return false;
    }
  };

  if (code === ApolloServerErrorCode.UNAUTHENTICATED) {
    content = 'Refresh the session or contact your rep if you repeatedly encounter this error.';
    icon = WARN;
    title = 'Your session has expired or your user is not authorized'
  }

  return { actionText, content, icon, onActionClick, title };
};

const CodedError = () => {
  const code = window.location.search && searchSplitter(window.location.search)?.code;

  const props = getErrorDisplay(code as ApolloServerErrorCodeType || 'GENERIC');

  return <NoResults {...props} />
};

export default CodedError;
